function GenralError(data, type) {
    this.name = type ? type : "GenralError";
    this.message = data.message;
    Error.call(this, data);
}
GenralError.prototype = new Error();

function CustomError(data, name) {
    this.filesize = "CustomError"
    this.name = name ? name : "CustomError";
    this.message = data;
    Error.call(this, data);
}
CustomError.prototype = new Error();

export const logError = (error, errorDesc, type, component, line, props) => {
    var transaction = window.elasticApm.startTransaction(`${type} error`, type);
    window.elasticApm.addLabels({ 'error-desc': errorDesc })
    window.elasticApm.addLabels({ 'error-component': component })
    window.elasticApm.addLabels({ 'error-Line': line })
    if (props) {
        Object.keys(props).forEach(k => {
            const pr = {};
            pr[`props-${k}`] = props[k];
            window.elasticApm.addLabels(pr);
        });
    }
    let errorobj;
    if (type == "GenralError") {
        errorobj = new GenralError(error)
    }
    else if (typeof error === 'string') {
        errorobj = new CustomError(error, type)
    }
    else {
        errorobj = new GenralError(error, type)
    }
    window.elasticApm.captureError(errorobj)
    transaction.end()
}